import { createFileRoute } from "@tanstack/react-router";
import { Share2 } from "lucide-react";
import { SentimentByChannel } from "@/components/ai-consumer-research/channels/channel-sentiment";
import { GrowthMomentum } from "@/components/ai-consumer-research/channels/growth-momentum";
import { Discussion } from "@/components/ai-consumer-research/channels/discussion";
import { ChannelHealth } from "@/components/ai-consumer-research/channels/channel-health";

export const Route = createFileRoute("/dashboard/consumer-research/_layout/channels")({
  component: Channels,
});

export function Channels() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 mb-6">
        <span className="flex size-9 items-center justify-center rounded-lg bg-muted">
          <Share2 className="size-5 text-muted-foreground" />
        </span>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Channel Deep Dive</h2>
          <p className="text-sm text-muted-foreground">Sentiment trends, growth signals & per-channel themes</p>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SentimentByChannel />
        <GrowthMomentum />
      </div>
      <Discussion />
      <ChannelHealth />
    </div>
  );
}
